const mixin = {
  props: {
    tooltip: {
      type: Boolean
    }
  },
  computed: {
    tooltipMsg () {
      if (!this.tooltip) {
        return undefined
      }
      return this.getTooltipMessage(this.name)
    }
  },
  methods: {
    getTooltipMessage (key) {
      let content = this.getMessage(key)
      if (!content) {
        return null
      }
      return '<header>' + this.getTitle(key) + '</header><div class="content">' + content + '</div>'
    },

    getTitle (key) {
      switch (key) {
        // écran information
        case 'objectif':
          return `Objectif de revenu`
        case 'sau':
          return 'Surface Agricole Utile'
        case 'dpb':
          return 'DPB'
        case 'commune':
          return 'Code postal et ville'
        // écran îlot
        case 'ru':
          return `R.U. (en mm)`
        case 'rfu':
          return `R.F.U  (en mm)`
        case 'charge_fixe':
          return `Charges fixes d’irrigation (en c€/m3)`
        case 'type_source':
          return `Source de prélèvement`
        case 'zre':
          return `Classement en ZRE`
        case 'ztm':
          return `Classement en ZTM`
        case 'ztq':
          return `Classement en ZTQ`
        case 'gestion_collective':
          return `Gestion collective`
        case 'redevance':
          return `Redevance de bassin (en c€/m3)`
        case 'pompage':
          return `Energie de pompage (en c€/m3)`
        case 'prix_irrigation':
          return `Charges opérationnelles d’irrigation (en c€/m3)`
        // écran culture
        case 'charges_fixes':
          return `Charges fixes d’exploitation (en €/ha)`
        case 'charges_variables':
          return `Charges opérationnelles d’exploitation (en €/ha)`
        case 'prix_tonne':
          return `Prix (en €/tonne)`
        case 'temps_travail':
          return `Temps de traction hors irrigation (en h/ha)`
        case 'rdt':
          return `Rendement potentiel (en q/ha)`
        case 'phenologique':
          return `Stade phénologique repère`
        case 'dose':
          return `Dose d’irrigation (en mm)`
        case 'temps_retour':
          return `Temps de retour (en jours)`
        case 'ref_stade_fin':
          return `Stade de fin`
        // écran simulation
        case 'config_ilot':
          return `Sélection des îlots`
        case 'scenario':
          return `Assolement et Dose maximale d’irrigation (en mm)`
        case 'priorisation':
          return `Priorisation des parcelles`
        case 'add_scenario':
          return `Etapes de configuration d’un scénario`
        case 'filtre_ilot':
          return `Filtre îlot`
        case 'marge_med':
          return `Marge nette`
        case 'marge_med_ha':
          return ``
        case 'marge_moy':
          return ``
        case 'marge_moy_ha':
          return ``
        case 'cv':
          return `Coefficient de variation (en %)`
        case 'freq_objectif':
          return `Fréquence d’atteinte des objectifs (en %)`
        case 'conso_med':
          return `Volume d’eau consommé pour l’irrigation`
        case 'conso_moy':
          return ``
        case 'graph_assolement':
          return `Graphique assolement`
        case 'graph_marge':
          return `Boxplot Marge nette`
        case 'graph_conso':
          return `Boxplot volume d’eau`
        case 'graph_rendement':
          return `Boxplot Rendement `
        case 'graph_temps':
          return `Temps de travail`
        case 'admin_simu_clim':
          return `Accès simulation climatique`
        case 'simu_clim':
        case 'simu_clim_annee':
          return `Simulation climatique`
        default:
          console.log('no title tooltip for', key)
          return undefined
      }
    },

    getMessage (key) {
      switch (key) {
        // écran information
        case 'objectif':
          return `L’objectif de revenu correspond à la somme que souhaite recevoir l’exploitant en termes de rémunération après paiement des impôts et charges sociales.`
        case 'sau':
          return 'Surface totale de l’exploitation'
        case 'dpb':
          return `Montant des aides PAC 1er pilier, unité exprimée à l'ha`
        case 'commune':
          return 'Il est indispensable de spécifier le code postal de l’exploitation'
        // écran îlot
        case 'ru':
          return `La réserve utile en eau d'un sol (RU) est la quantité d’eau que le sol peut absorber et restituer à la plante. La RU est autrement dit la différence entre l’humidité à la capacité au champ et l’humidité au point de flétrissement permanent.
            <br /><br />
            Une valeur (modifiable) est proposée par défaut, elle est issue de référentiels de catégorisation de sols type selon une région pédologique donnée.`
        case 'rfu':
          return `La réserve facilement utilisation (RFU) correspond à la quantité d'eau du sol en dessous de laquelle une plante flétrit. Les doses d'irrigation sont calculées à partir de la RFU et on irrigue dès que celle-ci est épuisée.
            <br /><br />
            Une valeur (modifiable) est proposée par défaut, elle est issue de référentiels de catégorisation de sols type selon une région pédologique donnée.`
        case 'charge_fixe':
          return `Les charges fixes d’irrigation correspondent à l’ensemble charges matérielles (matériel de pompage) en cours d’amortissement (forage, adduction, réparation, assurance) ainsi que les accès à la ressource (lacs ou retenues collinaires, abonnement électrique). Les  coûts liés à la main d’œuvre (pose, en cours de campagne, désinstallation) ne sont pas inclus dans ces charges.
            <br /><br />
            Une valeur (modifiable) peut être proposée par défaut selon le type de matériel sélectionné, la valeur inscrite par défaut correspond à des charges obtenues pour une installation d’irrigation optimisée (matériel et consommation d’énergie), sur une parcelle plane rectangulaire irrigant 30 ha de maïs grain  avec un apport de 250 mm/an.`
        case 'type_source':
          return `La source de prélèvement  conditionne le montant de la redevance appliqué selon qu’elle soit souterraine (nappes libres ou captives, nappes alluviales, etc.) ou superficielle (lacs, cours d’eau, retenue collinaire, etc.)`
        case 'zre':
          return `Les zones de répartition des eaux (ZRE) sont définies en application de l'article R211-71 du code de l'environnement, comme des "zones présentant une insuffisance, autre qu'exceptionnelle, des ressources par rapport aux besoins". Elles sont fixées par arrêté préfectoral. Ces zones sont soumises à des redevances de prélèvement majorées.`
        case 'ztm':
          return `Les ZTM (Zones à Taux Majoré) correspondent à des ressources, qui bien que n’ayant pas fait l’objet d’un arrêté préfectoral, sont classées comme des zones déficitaires en eau.`
        case 'ztq':
          return `Les ZTQ (Zones de Tension Quantitative) correspondent à des ressources, qui bien que n’ayant pas fait l’objet d’un arrêté préfectoral, sont classées comme des zones déficitaires en eau.`
        case 'gestion_collective':
          return `Dans les bassins où le déficit structurel de l'eau est particulièrement lié à l’agriculture, une gestion collective des prélèvements agricoles peut être mise en place sous l’égide des préfets. La répartition des volumes d’eau à usage agricole est progressivement confiée à un organisme unique de gestion collective (OUGC) sur un périmètre déterminé adapté. Le taux de redevance est alors minoré à un niveau hors ZRE.`
        case 'redevance':
          return `La redevance de bassin est fonction de critères variables selon l’Agence de l’Eau dont dépend l’exploitation, parmi lesquels la disponibilité, l’origine du prélèvement, son appartenance à une zone classée (ZRE, ZTM, ZTQ) ou un organisme unique gestion collective.`
        case 'pompage':
          return `Les pompes peuvent être alimentées au fuel ou par électricité. La quantité d'énergie consommée est fonction de la puissance des pompes, de leur débit et du volume d'eau apporté sur les cultures.
            <br /><br />
            Une valeur (modifiable) est proposée en fonction de la puissance moyenne du matériel considéré. Cette valeur correspond uniquement aux consommations (hors abonnement) ramenées au m3.`
        case 'prix_irrigation':
          return `Les charges variables d’irrigation (en c€/m3) sont obtenues en faisant la somme de la redevance de l’agence de bassin et de l’énergie de pompage.
            <br /><br />
            Dans le cas d’un scénario prospectif avec évolution du coût tarifaire de l’eau, il est possible de modifier manuellement cette valeur, qui servira de données d’entrée dans la simulation.`
        // écran culture
        case 'charges_fixes':
          return `Les charges fixes d’exploitation correspondent à l’ensemble des frais de fonctionnement de l’exploitation :  la rémunération de la main d’œuvre salariée (hormis la rémunération de la main  d’œuvre familiale) les coûts de mécanisation (entretien, réparation et amortissement technique du matériel, carburant, frais financiers) à l’exception des charges mécaniques liées à l’irrigation, les cotisations sociales (calculées  sur la moyenne des revenus professionnels de l’exploitant des trois dernières années) , les charges liées  au foncier (fermage) et les autres charges fixes liées au fonctionnement de l’exploitation (frais de gestion, assurances.).
            <br /><br />
            Une aide à la saisie (valeur modifiable) est proposée pour donner un ordre de grandeur, elle est obtenue à partir de fermes type représentatives du secteur sur la culture en question.`
        case 'charges_variables':
          return `Les charges opérationnelles d’exploitation correspondent à l’ensemble des charges intrants : charges Semences + charges Engrais + charges produits Phytosanitaires & autres charges intrants à l’exception des charges intrants liées à l’irrigation.
            <br /><br />
            Une aide à la saisie est proposée pour donner un ordre de grandeur, elle est obtenue à partir de fermes type représentatives du secteur sur la culture en question.`
        case 'prix_tonne':
          return `Si aucun prix de vente n’est renseigné, 500 scénarii de prix seront alors utilisés dans les calculs. Ces scénarii sont issus d’un historique et d’une loi de probabilité intégrant des corrélations entre cultures. Un seul prix fixe peut être renseigné, il sera alors utilisé pour les 20 scénarii climatiques.`
        case 'temps_travail':
          return `Il s’agit du temps moyen consacré à la culture, ramené à l’hectare et excluant le temps consacré à l’irrigation. Une valeur (modifiable) peut être proposée par défaut, issue de référentiels consolidés sur plusieurs exploitations type.`
        case 'rdt':
          return `Le rendement potentiel correspond au rendement d’une plante bien alimentée en eau (sans stress hydrique), conduite avec un niveau d’intrants adapté (protection, fertilisation). C’est un rendement proche des rendements atteints en grandes parcelles les meilleures années. Une valeur (modifiable) est proposée par défaut pour certaines cultures et régions, elle est issue de référentiels obtenus pour une culture et une région données. Il est indispensable de veiller à la cohérence entre cultures.`
        case 'phenologique':
          return 'Renseigner ici le stade à partir duquel la modalité d’irrigation est appliquée'
        case 'dose':
          return `La dose d’irrigation est indiquée en mm (30 mm = environ 1 tour d’eau), elle correspond à la dose maximale d’irrigation appliquée entre les deux stades phénologiques renseignés pour la culture en question.
          <br /><br />Pour simuler un arrêt d’irrigation entre deux stades de culture donnés, il est possible de renseigner ici une dose d’irrigation égale à 0 mm.
          <br /><br />Sur cette période, la culture ne sera pas irriguée.`
        case 'temps_retour':
          return 'Le temps de retour, exprimé en jours, correspond au temps minimum avant lequel la parcelle ne peut être de nouveau irriguée en raison des contraintes de roulement du matériel d’irrigation sur l’ensemble de l’îlot de culture.'
        case 'ref_stade_fin':
          return `Renseigner ici le stade à partir duquel l’irrigation est arrêtée.`
        // écran simulation
        case 'config_ilot':
          return `Dans le cas où l’utilisateur souhaite se focaliser spécifiquement sur un ou plusieurs îlots de son exploitation, il est possible de ne sélectionner qu’une partie des îlots et de configurer uniquement ces derniers.
          <br/>Ainsi, il est important de souligner que les résultats obtenus seront représentatifs de la surface du ou des îlots considérés.`
        case 'scenario':
          return `<b>L’assolement</b> est présenté sous forme d’un tableau relatif à un îlot et un type de sol donné. Ce tableau permet la répartition des surfaces utilisées pour chaque culture saisie au préalable dans l’onglet « Liste des cultures ».
            <br />Par défaut, la surface saisie est égale à 0.
            <br /><br />
            <b>La dose maximale d’irrigation</b> correspond au volume d’eau maximum que l’on souhaite apporter à une culture donnée
            <br/> Par défaut, aucune dose limite n’est entrée et si aucune limitation n’est imposée sur l’îlot (volume, débit, période d’irrigation), la culture est alors irriguée jusqu’à son optimum (à l’ETM).
            <br />Cette dose maximale peut correspondre à une stratégie de pilotage a priori.
            <br />Pour une dose d’irrigation spécifiée à 0, la culture n’est plus irriguée.`
        case 'priorisation':
          return `Cette fonctionnalité ne s’applique que sur les îlots irrigués et les cultures sur lesquelles une stratégie d’irrigation a été saisie au préalable.
            <br />Dans le cas d’un volume ou d’un accès à l’eau limités, les cultures sélectionnées et ordonnées auront prioritairement accès à l’eau (dans l’ordre du classement) jusqu’à épuisement du quota d’eau (selon volume, débit ou date limite définis) pour une simulation donnée.`
        case 'add_scenario':
          return `A l’ajout d’un scénario,  je réalise les 3 étapes suivantes :
          <br /><br />1. Je saisis les surfaces des différentes cultures que je souhaite faire figurer dans mon assolement. La totalité des surfaces saisies doit être égale à la surface totale renseignée pour l’îlot.
          <br /><br />2. Je spécifie si nécessaire une dose limite d’alimentation hydrique pour ma culture. Par défaut, il n’y a pas de dose limite. Une dose d’irrigation spécifiée à 0 revient à conduire la culture en sec.
          <br /><br />3. Je configure les priorités d’irrigation pour chacun des scénarii à partir du bouton ‘Gérer les priorités’. Les cultures priorisées sont signalées par un encart chiffré rappelant l’ordre de priorité établi au sein d’un îlot et d’un scénario donnés.`
        case 'filtre_ilot':
          return `Les résultats peuvent être affichés par îlot, par exemple pour comparer différents scénarios d’assolement sur un îlot irrigué et un îlot non irrigué. <br />A l’échelle d’une culture, les résultats se raisonnent à l’îlot (mêmes conduites de culture).<br />Un îlot est défini par une capacité d’irrigation donnée et un type de matériel (débit, volume d’eau autorisé, période d’irrigation, etc.) définis dans les paramètres généraux de l’îlot.`
        // résultat simulation
        case 'marge_med':
          return `La marge nette ici calculée correspond au revenu dégagé par l’exploitant agricole après soustraction de l’ensemble des charges opérationnelles et fixes sur l’exploitation (hors rémunération familiale). Elle peut être totale ou calculée à l’hectare; à l’échelle de l’exploitation ou à celle de l’îlot. Par défaut, elle n’inclut pas les droits à paiement de base mais cette option peut être cochée depuis l’interface.
          <br/> <br/>Elle est calculée à partir du calcul suivant :
          <br/>Prix de vente x Rendement (+ Aide DPB) – charges (semences, engrais, produits phytosanitaires, autres intrants) – charges de mécanisation (amortissement technique, entretien et réparation, frais financiers, carburant) – charges main d’œuvre salariale – cotisations sociales MSA (calculées  sur la moyenne des revenus professionnels de l’exploitant des trois dernières années) – charges liées au foncier (établi sur la base du fermage`
        case 'marge_med_ha':
          return ``
        case 'marge_moy':
          return ``
        case 'marge_moy_ha':
          return ``
        case 'cv':
          return `Le coefficient de variation est un indicateur de dispersion des valeurs autour de la moyenne (rapport de l’écart type à la moyenne), exprimé en pourcentage.
          <br />Plus le coefficient est élevé, plus la dispersion est importante autour de la moyenne.`
        case 'freq_objectif':
          return `Cet indicateur exprimé en pourcentage permet d’estimer pour un scénario donné la probabilité d’atteinte de l’objectif de résultat fixé en début d’exercice, en tenant compte des incertitudes économiques et climatiques.`
        case 'conso_med':
          return `Le volume d’eau consommé pour l’irrigation peut être raisonné à l’échelle de l’exploitation ou d’un îlot de culture.
          <br/ >S’il correspond au volume maximum spécifié pour l’îlot en question, le quota a certainement été atteint et les cultures en question n’ont pu être irriguées  à l’ETM.
          <br /><br />A contrario, cet indicateur permet de rendre compte de l’impact de différentes pratiques culturales (ex : îlot irrigué versus îlot en conditions pluviales) sur le rendement d’une culture et ses répercussions économiques.`
        case 'conso_moy':
          return ``
        case 'graph_assolement':
          return `Ce graphique présente les différentes stratégies d’assolement entrées préalablement par l’utilisateur, à l’échelle de l’exploitation ou d’un îlot de culture.`
        case 'graph_marge':
          return `Afin de représenter graphiquement la variabilité climatique et économique des productions, la représentation des résultats de marge nette par une "boite à moustaches" est la plus indiquée.
          <br /><br />
          Elle permet de visualiser différentes informations :
          <br />
          <ul>
          <li>La moyenne (en pointillés) de la marge nette,
          <li>La médiane (en trait plein),  qui signifie qu’il existe autant de valeur supérieures qu’inférieures à cette valeur dans l’ensemble des résultats de marge nette,
          <li>Le rectangle (ou boite), qui contient 50%  des résultats obtenus,
          <li>Les branches hautes et basses (ou moustaches), qui contiennent respectivement 25% des valeurs les plus élevées et 25% des valeurs les plus basses,
          <li>Les extrémités, qui renseignent sur les valeurs minimum et les valeurs maximum de marge nette.
          <ul>
          <br /><br />
          La boxplot s’affiche par défaut aides incluses, cette option peut être décochée via l’encart situé au-dessus du graphique.
          Cette boite à moustaches traduit la variabilité de 20 scénarii climatiques associés à un ou 500 scénarii de prix. Cette boite illustre donc la variabilité de 20 ou 10000 valeurs, qui peuvent être comparées à l’objectif de revenu.`
        case 'graph_conso':
          return `Le volume d’eau consommé peut varier pour un même scénario en fonction des conditions climatiques d’une année sur l’autre (plus ou moins d’irrigation nécessaire selon la pluviométrie, l’ensoleillement, etc.).
          <br />Une représentation de type "boite à moustaches" a été choisie et permet de visualiser les informations suivantes:
          <br />
          <ul>
          <li>La moyenne (en pointillés) du volume d’eau consommé,
          <li>La médiane (en trait plein),  qui signifie qu’il existe autant de valeur supérieures qu’inférieures à cette valeur dans l’ensemble des résultats de consommation hydrique,
          <li>Le rectangle (ou boite), qui contient 50%  des résultats obtenus,
          <li>Les branches hautes et basses (ou moustaches), qui contiennent respectivement 25% des valeurs les plus élevées et 25% des valeurs les plus basses,
          <li>Les extrémités, qui renseignent sur les valeurs minimum et les valeurs maximum volume d’eau consommé.
          </ul>
          <br/><br/>
          Cet ensemble de valeurs peut être comparé au volume maximum disponible à l’échelle d’un îlot.
          `
        case 'graph_rendement':
          return `Ce graphique présente l’ensemble des valeurs de rendements (q/ha) pour une culture et pour chaque type de sol, représentées sous la forme de « boites à moustache qui traduisent la variabilité de 20 scénarii climatiques. ».<br />L’ensemble de valeurs représentées sous cette forme peut être comparé au rendement potentiel de chaque culture qui correspond au rendement de la culture en conditions de confort hydrique (sans stress hydrique).`
        case 'graph_temps':
          return `Ce graphique présente le temps de travail total passé sur l’exploitation ou sur un îlot de culture.
          <br />Il s’agit d’une approche globale, non affinée, non liée à un calendrier d’activités qui permet de comparer différents scénarii en termes de besoin en main d’œuvre.`
        case 'admin_simu_clim':
          return `Permet à l'utilisateur de sélectionner un fichier météo de simulation climatique passée ou de projection climatique future`
        case 'simu_clim':
          return `L’outil de simulation climatique va modifier l’appel moteur pour que celui-ci soit calculé non pas avec les coordonnées des stations météo des parcelles pour les 20 dernières années, mais avec un fichier météo de simulation climatique passée ou de projection climatique future, à sélectionner dans la liste déroulante.
          <br /><br />
            L'enregistrement du choix ne sera fait qu'avec un appel au moteur`
        case 'simu_clim_annee':
          return `L’année de campagne maximale du fichier météo choisi permettra d’utiliser les 20 dernières années climatiques.
          <br /><br />
          Par exemple, en choisissant 2015, les calculs se feront de 1996 à 2015.`
        default:
          console.log('no tooltip for', key)
          return undefined
      }
    }
  }
}

export default mixin
